export var PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export var pageSizeDataOptions = PAGE_SIZE_OPTIONS.map(function (size) { return ({
    value: String(size),
    label: String(size),
}); });
export var DEFAULT_PAGE_SIZE = 20;
export var PAGE_SIZE_STORAGE_KEY = "br-agency.pageSize";
/**
 * localStorage key prefix for per-list column layout (order + widths). The concrete key is
 * `${COLUMN_LAYOUT_STORAGE_KEY_PREFIX}.${layoutKey}`, e.g. `br-agency.columnLayout.titles`.
 */
export var COLUMN_LAYOUT_STORAGE_KEY_PREFIX = "br-agency.columnLayout";
/** Stable per-list layout keys used to persist column order/width in the browser. */
export var COLUMN_LAYOUT_KEYS = {
    TITLES: "titles",
    PRODUCTS: "products",
    PRODUCT_NUMBERS: "productNumbers",
};
/** Minimum column width (px) enforced while resizing, so a column can never be dragged away. */
export var COLUMN_MIN_WIDTH = 40;
/**
 * ONIX publishing status (codelist 64) values for which an ISBN/ISMN must never be assigned:
 * `01` = Cancelled ("Zrušeno"), `03` = Postponed indefinitely ("Odloženo na neurčito").
 */
export var PUBLISHING_STATUS_CANCELLED = "01";
export var PUBLISHING_STATUS_POSTPONED_INDEFINITELY = "03";
export var NON_ASSIGNABLE_PUBLISHING_STATUSES = [
    PUBLISHING_STATUS_CANCELLED,
    PUBLISHING_STATUS_POSTPONED_INDEFINITELY,
];
/**
 * Whether the given publishing status forbids assigning a product number. Only the forward case is
 * guarded on the client (the status is chosen/known before assignment); numbers already assigned before
 * the status changed to 01/03 are intentionally left untouched. A missing status never blocks.
 *
 * @param publishingStatusValue the ONIX publishing status value (e.g. "01", "03", "04")
 * @returns true only for Cancelled (01) or Postponed indefinitely (03)
 */
export var isPublishingStatusBlockingAssign = function (publishingStatusValue) {
    return !!publishingStatusValue &&
        NON_ASSIGNABLE_PUBLISHING_STATUSES.includes(publishingStatusValue);
};
